export * from './HandRightIcon'
